import DeliveryType from './DeliveryType'

export default class PaymentMode {
  static get PayNow () { return 'pay_now' }
  static get PayLater () { return 'pay_later' }
  static get Courier () { return 'courier' }

  // у полного ресурса режим лежит в paymentMode, у списка заказов - только в payment.mode
  static ofOrder (order) {
    return order?.paymentMode || order?.payment?.mode || null
  }

  static getName (enumValue) {
    switch (enumValue) {
      case PaymentMode.PayNow:
        return 'Оплатить сейчас'

      case PaymentMode.PayLater:
        return 'Оплата позже'

      case PaymentMode.Courier:
        return 'Оплата курьеру'

      default:
        return enumValue
    }
  }

  // подпись позиции в переключателе окна оплаты: у доставки «сейчас» - это оплата на кассе точки
  static getPickLabel (enumValue, deliveryType) {
    if (enumValue === PaymentMode.PayNow && !!deliveryType && deliveryType !== DeliveryType.Self) {
      return 'Оплатить на кассе'
    }

    return PaymentMode.getName(enumValue)
  }
}
